:host {
  display: contents;
}

.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-5);
  font-family: var(--font-sans);
  color: var(--color-gray-900);
  padding: var(--spacing-6) 0;
}

.processing-body {
  align-items: center;
  justify-content: center;
  gap: var(--spacing-5);
  padding: var(--spacing-6);
}

.processing-spinner {
  align-self: center;
}

/* ============================================================================
 * Summary Section (heading + card + notice)
 * ========================================================================= */

.summary-section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-5);
}

.summary-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--spacing-2);
  margin: 0;
  font-weight: var(--font-weight-bold);
  line-height: 1.3;
  color: var(--color-gray-900);
}

.summary-count {
  font-size: var(--text-5xl);
}

.summary-label {
  padding-bottom: var(--spacing-1_5);
  font-size: var(--text-base);
}

.notice {
  margin: 0;
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
  color: var(--color-gray-500);
}

/* ============================================================================
 * Slotted action buttons — sizing overrides
 * ========================================================================= */

.report-button::part(button) {
  min-width: var(--spacing-44);
  min-height: var(--spacing-10);
}

.upload-button::part(button) {
  min-height: var(--spacing-10);
  background: var(--color-gray-50);
}

/* ============================================================================
 * Error Alert
 * ========================================================================= */

.error-alert {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  width: 100%;
  padding: var(--spacing-4);
  border: 1px solid var(--color-red-600);
  border-radius: var(--radius-lg);
  background: var(--color-red-50);
}

.error-alert-heading {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.error-alert-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-5);
  height: var(--spacing-5);
  flex: 0 0 var(--spacing-5);
  color: var(--color-red-600);
}

.error-alert-icon hcds-icon {
  --hcds-icon-size: var(--spacing-5);
  display: block;
}

.error-alert-title {
  margin: 0;
  font-size: var(--text-base);
  line-height: var(--leading-normal);
}

.error-alert-message {
  margin: 0;
  font-size: var(--text-xs);
  line-height: var(--leading-normal);
}

/* ============================================================================
 * Screen-reader only utility
 * ========================================================================= */

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
